export default {
  keycloak: (state) => state.keycloak,
};
